module.exports = __webpack_public_path__ + "static/laptop_q-684ac6a779aefc58cd135587878b529b.png";